export const roundMoney = (value) => Math.round((Number(value) + Number.EPSILON) * 100) / 100;

// Largest-remainder allocation: every paise belongs to exactly one line.
export function allocateMoney(weights, amount) {
  const total = weights.reduce((a,b)=>a+b,0);
  if (!total) return weights.map(()=>0);
  const cents = Math.round(amount*100);
  const raw = weights.map(w=>w/total*cents);
  const parts = raw.map(v=>Math.floor(v+1e-9));
  const order = raw.map((v,i)=>i).sort((a,b)=>(raw[b]-parts[b])-(raw[a]-parts[a]) || a-b);
  const remainder=cents-parts.reduce((a,b)=>a+b,0);
  for(let i=0;i<remainder;i++) parts[order[i]]++;
  return parts.map(v=>v/100);
}

export function calculatePOSTotals(items, discount = 0) {
  let subtotal = 0;
  const taxes = {};
  const amounts = items.map(item=>roundMoney((item.uom==='KG' ? Number(item.grams||0)/1000 : Number(item.qty||0))*Number(item.overriddenPrice??item.price??0)));
  const shares = allocateMoney(amounts, discount);
  for (const [index,item] of items.entries()) {
    const qty = item.uom === "KG" ? Number(item.grams || 0) / 1000 : Number(item.qty || 0);
    const amount = roundMoney(qty * Number(item.overriddenPrice ?? item.price ?? 0));
    subtotal = roundMoney(subtotal + amount);
    const configured = item.gst_mode === 'none' ? [] : item.taxes || [];
    const rate = configured.reduce((s,t)=>s+Number(t.percent),0);
    const included = roundMoney((amount-shares[index])*rate/(100+rate));
    const parts = allocateMoney(configured.map(t=>Number(t.percent)),included);
    for (const [i,tax] of configured.entries()) {
      taxes[tax.name] = roundMoney((taxes[tax.name] || 0) + parts[i]);
    }
  }
  const gross = roundMoney(subtotal - roundMoney(discount));
  return { subtotal, taxes, gross, total: gross, roundOff: 0,
    taxable: roundMoney(gross-Object.values(taxes).reduce((s,v)=>s+v,0)) };
}
